export const LANGUAGES = {
  ru: {
    code: 'ru',
    name: 'Русский',
    shortName: 'Ru',
  },
  en: {
    code: 'en',
    name: 'English',
    shortName: 'En',
  },
};
